import {
  AcceptedCountries,
  AcceptedCountriesLabels,
  AvailableLanguage,
  AvailableLanguageLabel,
  PhoneNumberRegistrationBlockedCountry,
} from './internationalEnums';
import { Country, Language } from './internationalInterfaces';

export const availableLanguages: Language[] = [
  {
    short: AvailableLanguage.ENGLISH,
    long: AvailableLanguageLabel.ENGLISH,
  },
  {
    short: AvailableLanguage.GERMAN,
    long: AvailableLanguageLabel.GERMAN,
  },
  {
    short: AvailableLanguage.SPANISH,
    long: AvailableLanguageLabel.SPANISH,
  },
  {
    short: AvailableLanguage.FRANCAIS,
    long: AvailableLanguageLabel.FRANCAIS,
  },
  {
    short: AvailableLanguage.HINDI,
    long: AvailableLanguageLabel.HINDI,
  },
  {
    short: AvailableLanguage.MAGYAR,
    long: AvailableLanguageLabel.MAGYAR,
  },
  {
    short: AvailableLanguage.PORTUGUESE_BRAZIL,
    long: AvailableLanguageLabel.PORTUGUESE_BRAZIL,
  },
  {
    short: AvailableLanguage.FINNISH,
    long: AvailableLanguageLabel.FINNISH,
  },
];

export const africanCountries = [AcceptedCountries.KENYA];

export const acceptedAfricanCountriesList: Country[] = [
  {
    code: AcceptedCountries.KENYA,
    name: AcceptedCountriesLabels.KENYA,
  },
];

export const acceptedCountriesList: Country[] = [
  {
    code: AcceptedCountries.GREAT_BRITAIN,
    name: AcceptedCountriesLabels.GREAT_BRITAIN,
  },
  {
    code: AcceptedCountries.IRELAND,
    name: AcceptedCountriesLabels.IRELAND,
  },
  {
    code: AcceptedCountries.ARMENIA,
    name: AcceptedCountriesLabels.ARMENIA,
  },
  {
    code: AcceptedCountries.AUSTRIA,
    name: AcceptedCountriesLabels.AUSTRIA,
  },
  {
    code: AcceptedCountries.BOSNIA_AND_HERZEGOVINA,
    name: AcceptedCountriesLabels.BOSNIA_AND_HERZEGOVINA,
  },
  {
    code: AcceptedCountries.CROATIA,
    name: AcceptedCountriesLabels.CROATIA,
  },
  {
    code: AcceptedCountries.FINLAND,
    name: AcceptedCountriesLabels.FINLAND,
  },
  {
    code: AcceptedCountries.HUNGARY,
    name: AcceptedCountriesLabels.HUNGARY,
  },
  {
    code: AcceptedCountries.KOSOVO,
    name: AcceptedCountriesLabels.KOSOVO,
  },
  {
    code: AcceptedCountries.MONTENEGRO,
    name: AcceptedCountriesLabels.MONTENEGRO,
  },
  {
    code: AcceptedCountries.NEW_ZEALAND,
    name: AcceptedCountriesLabels.NEW_ZEALAND,
  },
  {
    code: AcceptedCountries.NORWAY,
    name: AcceptedCountriesLabels.NORWAY,
  },
  {
    code: AcceptedCountries.SERBIA,
    name: AcceptedCountriesLabels.SERBIA,
  },
  {
    code: AcceptedCountries.SLOVAKIA,
    name: AcceptedCountriesLabels.SLOVAKIA,
  },
  {
    code: AcceptedCountries.SLOVENIA,
    name: AcceptedCountriesLabels.SLOVENIA,
  },
  {
    code: AcceptedCountries.SWITZERLAND,
    name: AcceptedCountriesLabels.SWITZERLAND,
  },
  {
    code: AcceptedCountries.GEORGIA,
    name: AcceptedCountriesLabels.GEORGIA,
  },
  {
    code: AcceptedCountries.UNITED_ARAB_EMIRATES,
    name: AcceptedCountriesLabels.UNITED_ARAB_EMIRATES,
  },
  {
    code: AcceptedCountries.CANADA,
    name: AcceptedCountriesLabels.CANADA,
  },
  {
    code: AcceptedCountries.BRAZIL,
    name: AcceptedCountriesLabels.BRAZIL,
  },
  {
    code: AcceptedCountries.INDIA,
    name: AcceptedCountriesLabels.INDIA,
  },
  {
    code: AcceptedCountries.MEXICO,
    name: AcceptedCountriesLabels.MEXICO,
  },
  {
    code: AcceptedCountries.COLOMBIA,
    name: AcceptedCountriesLabels.COLOMBIA,
  },
  {
    code: AcceptedCountries.CHILE,
    name: AcceptedCountriesLabels.CHILE,
  },
  {
    code: AcceptedCountries.PERU,
    name: AcceptedCountriesLabels.PERU,
  },
  {
    code: AcceptedCountries.ARGENTINA,
    name: AcceptedCountriesLabels.ARGENTINA,
  },
  {
    code: AcceptedCountries.ECUADOR,
    name: AcceptedCountriesLabels.ECUADOR,
  },
  {
    code: AcceptedCountries.EL_SALVADOR,
    name: AcceptedCountriesLabels.EL_SALVADOR,
  },
  {
    code: AcceptedCountries.PARAGUAY,
    name: AcceptedCountriesLabels.PARAGUAY,
  },
  {
    code: AcceptedCountries.URUGUAY,
    name: AcceptedCountriesLabels.URUGUAY,
  },
];

export const kwiffDomainWhiteListedCountries = [AcceptedCountries.GREAT_BRITAIN as string, AcceptedCountries.IRELAND as string];

export const withdrawalBlackListedCountriesUnverifiedAccount = [
  AcceptedCountries.IRELAND,
  AcceptedCountries.ARMENIA,
  AcceptedCountries.AUSTRIA,
  AcceptedCountries.BOSNIA_AND_HERZEGOVINA,
  AcceptedCountries.CROATIA,
  AcceptedCountries.FINLAND,
  AcceptedCountries.HUNGARY,
  AcceptedCountries.KOSOVO,
  AcceptedCountries.MONTENEGRO,
  AcceptedCountries.NEW_ZEALAND,
  AcceptedCountries.NORWAY,
  AcceptedCountries.SERBIA,
  AcceptedCountries.SLOVAKIA,
  AcceptedCountries.SLOVENIA,
  AcceptedCountries.SWITZERLAND,
  AcceptedCountries.GEORGIA,
  AcceptedCountries.UNITED_ARAB_EMIRATES,
  AcceptedCountries.CANADA,
  AcceptedCountries.BRAZIL,
  AcceptedCountries.INDIA,
  AcceptedCountries.MEXICO,
  AcceptedCountries.COLOMBIA,
  AcceptedCountries.CHILE,
  AcceptedCountries.PERU,
  AcceptedCountries.ARGENTINA,
  AcceptedCountries.ECUADOR,
  AcceptedCountries.EL_SALVADOR,
  AcceptedCountries.PARAGUAY,
  AcceptedCountries.URUGUAY,
];

export const promotionTabsWhiteListedCountries = [
  AcceptedCountries.GREAT_BRITAIN,
  AcceptedCountries.IRELAND,
  AcceptedCountries.FINLAND,
  AcceptedCountries.BRAZIL,
];

export const americanOddsWhiteListedCountries = [AcceptedCountries.CANADA];

export const bypassReCaptchaWhiteListCountries = [AcceptedCountries.KENYA];

export const signupMandatoryFirstDepositCountriesList = [AcceptedCountries.GREAT_BRITAIN];

export const depositAcknowledgeDialogDisplayForCountries = [AcceptedCountries.GREAT_BRITAIN];

export const termsAndConditionsAutoCheckedForCountries = [AcceptedCountries.KENYA];

export const countriesWithCallUs = [AcceptedCountries.KENYA];

export const countriesWithBetTaxes = [AcceptedCountries.KENYA];

export const walletProfitAndLossBlockedCountries = [AcceptedCountries.KENYA];

export const referAFriendEligibleCountries = [AcceptedCountries.GREAT_BRITAIN];

export const hideStayingInControlForCountries = [AcceptedCountries.KENYA];

export const hideResponsibleGamblingForCountries = [AcceptedCountries.KENYA];

export const hideCloseAccountForCountries = [AcceptedCountries.KENYA];

export const hideRAFButtonFromSurpriseBetCountries = [AcceptedCountries.KENYA];

export const hideShareButtonFromSurpriseBetCountries = [AcceptedCountries.KENYA];

export const displayHROnFeaturedPageCountries = [AcceptedCountries.GREAT_BRITAIN, AcceptedCountries.IRELAND];

export const hideAccountDetailsForCountries = [AcceptedCountries.KENYA];

export const hideVerificationForCountries = [AcceptedCountries.KENYA];

export const cancelWithdrawalBlockedCountries = [AcceptedCountries.GREAT_BRITAIN];

export const countriesWithHiddenPaymentLogosInFooter = [AcceptedCountries.NEW_ZEALAND];

export const countriesWithoutCorporateLinksInFooter = [AcceptedCountries.NEW_ZEALAND];

export const countriesWithHiddenFooterForGhostUsers = [AcceptedCountries.NEW_ZEALAND];

export const countriesWithoutCookies = [AcceptedCountries.BRAZIL, AcceptedCountries.KENYA, AcceptedCountries.INDIA];

export const COUNTRIES_WITH_FRONTEND_DISABLED_CASINO = [AcceptedCountries.KENYA];

export const COUNTRIES_WITH_AVIATOR_GAME_IN_MENU = [AcceptedCountries.KENYA];

export const COUNTRIES_WITHOUT_CLOSED_LOOP_WITHDRAWALS = [AcceptedCountries.KENYA];

export const registrationBlockedPhoneNumberCountries = [
  PhoneNumberRegistrationBlockedCountry.CAMBODIA,
  PhoneNumberRegistrationBlockedCountry.MYANMAR,
  PhoneNumberRegistrationBlockedCountry.VIETNAM,
  PhoneNumberRegistrationBlockedCountry.LAOS,
  PhoneNumberRegistrationBlockedCountry.NORTH_KOREA,
  PhoneNumberRegistrationBlockedCountry.IRAN,
  PhoneNumberRegistrationBlockedCountry.CHINA,
  PhoneNumberRegistrationBlockedCountry.SRI_LANKA,
  PhoneNumberRegistrationBlockedCountry.SWEDEN,
];

export const BETKWIFF_DOMAIN = 'betkwiff';
export const KWIFF_DOMAIN = 'kwiff';

export const BETKWIFF_BRAND_NAME = 'betkwiff';
export const KWIFF_BRAND_NAME = 'kwiff';

export const PROJECT_PHOENIX_BRAND_NAME = 'ProjectPhoenix';

export const INTERNATIONAL_CODE_USED_BY_PHONE_LIB = 'ZZ';

export const CountryStateISOA2 = {
  CANADA: {
    ONTARIO: 'ON',
  },
  ARGENTINA: {
    BUENOS_AIRES: 'B',
  },
};

export const blockedStatesByCountry: { [key: string]: string[] } = {
  [AcceptedCountries.CANADA]: [CountryStateISOA2.CANADA.ONTARIO],
  [AcceptedCountries.ARGENTINA]: [CountryStateISOA2.ARGENTINA.BUENOS_AIRES],
};

export const forceBlockSystemBetsForCountries = [AcceptedCountries.KENYA];

export const CountrySpecificLanguage = {
  ENGLISH: {
    GREAT_BRITAIN: 'en-GB',
    IRELAND: 'en-IE',
    NEW_ZEALAND: 'en-NZ',
    INDIA: 'en-IN',
    CANADA: 'en-CA',
  },
  FINNISH: {
    FINLAND: 'fi-FI',
  },
  MAGYAR: {
    HUNGARY: 'hu-HU',
  },
  HINDI: {
    INDIAN: 'hi-IN',
  },
  FRANCAIS: {
    FRANCE: 'fr-FR',
  },
  SPANISH: {
    SPAIN: 'es-ES',
    MEXICO: 'es-MX',
    COLOMBIA: 'es-CO',
    CHILE: 'es-CL',
    PERU: 'es-PE',
    ARGENTINA: 'es-AR',
    ECUADOR: 'es-EC',
    EL_SALVADOR: 'es-SV',
    PARAGUAY: 'es-PY',
    URUGUAY: 'es-UY',
  },
  GERMAN: {
    DEUTSCHLAND: 'de-DE',
    AUSTRIA: 'de-AT',
    SWITZERLAND: 'de-CH',
  },
  PORTUGUESE: {
    BRAZIL: 'pr-BR',
  },
};
